import { PracovnyKrokCompleteApi } from 'elegislativa-frontend-ts-axios';
import { ClientResponse } from '../../model/ClientResponse';
import apiConfiguration from '../configuration/apiConfiguration';
import { elegislativaPrefixPath } from '../configuration/apiConfigurationConstants';
import PracovnyKrokEnum from '../../model/pracovnyKrok/PracovnyKrokEnum';

const client = new PracovnyKrokCompleteApi(apiConfiguration(elegislativaPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const completePracovnyKrok = async (
  type: string,
  year: number,
  index: number,
  pracovnyKrokId: string,
  pracovnyKrok: PracovnyKrokEnum,
  headers?: object,
): Promise<ClientResponse<void>> => {
  const { status } = await client.completePracovnyKrok(type, year, index, pracovnyKrokId, pracovnyKrok, headers);
  return { responseCode: status };
};
